export default __webpack_public_path__ + "img/13fe6fd9c753d9aab9bc134d670fbe8b.svg";